import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { IBucketItem } from '../models/bucket-item.model';
import { GenericExtensionsService } from '../../../extensions/generic-extensions-service';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-file-meta-data',
    templateUrl: './file-meta-data.component.html',
    styleUrls: ['./file-meta-data.component.scss'],
    imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatTooltip, DatePipe]
})

export class FileMetaDataComponent implements OnInit {
  private genericExtensionService = inject(GenericExtensionsService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() clickedBucketItem: Partial<IBucketItem> = {};
  @Input() expanded: boolean = false;
  public fileSize:string ="";
  public fileSizeInBytes:string ="";
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "file-meta-data";

  ngOnInit() {
     this.fileSize = this.genericExtensionService.formatBytes(this.clickedBucketItem.Size);
     this.fileSizeInBytes = this.clickedBucketItem.Size.toString() + ' Bytes';
    }

  public onPanelToggle(): void {
    this.cdr.detectChanges();
  }

  public buildControlId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join('-');
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return this.slugify(value);
    }
    return '00';
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }
}
